import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import { useNavigateToPost } from "@/react/components/PostsV3/PostModal/hooks/useNavigateToPost";
import { usePostNavigationContext } from "@/react/components/PostsV3/PostViewList/PostNavigationContext";
import type { Notification } from "@circle-react/types/Notification";
import { DefaultNotificationContent } from "./DefaultNotificationContent";

export const CommentNotification = ({
  notification,
  onClickHandler,
  isMarkedAsRead,
  shouldFocusOnCommentsSection,
}: {
  notification: Notification;
  onClickHandler: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  isMarkedAsRead: boolean;
  shouldFocusOnCommentsSection: boolean;
}) => {
  const { pathname } = useLocation();

  const actionPath = notification.action_web_path?.split("#")[0]; // Removing comment wrapper from the action path
  const isOnSamePage = actionPath === pathname;

  const { navigateToPost } = useNavigateToPost();
  const { params, hasNextPage } = usePostNavigationContext();

  if (isOnSamePage) {
    return (
      <a
        href={notification.action_web_path}
        onClick={onClickHandler}
        className="w-full"
      >
        <DefaultNotificationContent
          notification={notification}
          isMarkedAsRead={isMarkedAsRead}
        />
      </a>
    );
  }

  return (
    <Link to={notification.action_web_path} className="w-full">
      <button
        type="button"
        onClick={(event: any) => {
          onClickHandler(event);
          if (event.metaKey || event.ctrlKey) {
            return;
          }
          event.preventDefault();
          navigateToPost({
            pathname: notification.action_web_path,
            prevLocation: location as any,
            params,
            hasNextPage,
            shouldFocusOnCommentsSection: shouldFocusOnCommentsSection,
            shouldDisableNavigation: true,
          });
        }}
        className="w-full text-left"
      >
        <DefaultNotificationContent
          notification={notification}
          isMarkedAsRead={isMarkedAsRead}
        />
      </button>
    </Link>
  );
};
